import React, {useEffect, useState} from 'react';
import globalContext from '../../../../config/context';

import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField/TextField';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 300,
    marginTop: 5,
  },
  comboBox: {
    width: '100%',
    paddingBottom: 10,
    disabled: 'true',
  },
  textField: {
    width: '100%',
    paddingBottom: 10,
  },
}));

const DialogTitikPusat = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{centroidLatitude, centroidLongitude}, {setCentroidLatitude, setCentroidLongitude}] = useAppContext();
  const {onTitikPusat} = props;

  return (
    <div className={classes.root}>
      <TextField
        id="outlined-basic"
        className={classes.textField}
        label="Latitude"
        variant="outlined"
        value={centroidLatitude}
        onChange={(e) => setCentroidLatitude(e.target.value)}
      />

      <TextField
        id="outlined-basic"
        className={classes.textField}
        label="Longitude"
        variant="outlined"
        value={centroidLongitude}
        onChange={(e) => setCentroidLongitude(e.target.value)}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            onTitikPusat();
          }
        }}
      />
    </div>
  );
};

export default DialogTitikPusat;
